<template>
  <!-- 右侧主体面板 -->
  <div class="crm-client-container">
    <!-- 面包屑导航 -->
    <Breadcrumb :levelList="levelList" />
    <!-- 侧边客户筛选条件 -->
    <div class="crm-client-aside">
      <div class="crm-select-con">
        客户筛选
      </div>
      <el-scrollbar class="crm-group">
        <el-checkbox-group v-model="checkList" @change="handleCheckChange">
          <el-collapse v-model="activeName">
            <el-collapse-item
              v-for="(item, idx) in openColList"
              :key="item.nameEn+item.name"
              :name="item.name"
            >
              <template slot="title">
                <el-checkbox :label="item.name"></el-checkbox>
              </template>
              <!-- 分类1:姓名、负责人、手机、邮箱、地址（搜索） -->
              <div v-if="item.styleType === 'textfield'" class="crm-search">
                <el-select v-model="openColList[idx]['condition']" @change="handleSearch" clearable>
                  <el-option
                    v-for="item in conditionLevelList"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                  />
                </el-select>
                <el-input
                  v-if="openColList[idx]['condition'] !== 'IS_NULL' && openColList[idx]['condition'] !== 'IS_NOT_NULL'"
                  clearable
                  class="crm-input"
                  type="text"
                  v-model="openColList[idx]['value']"
                  @blur="handleSearch"
                  @clear="handleSearch"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </div>
              <!-- 自定义字段数字 -->
              <div v-if="item.styleType === 'number'" class="crm-search">
                <el-input
                  clearable
                  class="crm-input"
                  type="number"
                  v-model="openColList[idx]['value']"
                  @blur="handleSearch"
                  @clear="handleSearch"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </div>
              <!-- 自定义字段下拉单选 -->
              <div v-if="item.styleType === 'radio'" class="crm-search">
                <el-select
                  v-model="openColList[idx]['value']"
                  @change="handleSearch"
                  value-key="idx"
                  clearable
                >
                  <el-option
                    v-for="item in openColList[idx][item.nameEn + 'list']"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  />
                </el-select>
              </div>
              <!-- 标签 （下拉多选）-->
              <div v-else-if="item.nameEn === 'label'">
                <el-select
                  v-model="openColList[idx]['value']"
                  multiple
                  @change="handleSearch"
                  value-key="idx"
                >
                  <el-option
                    v-for="item in labelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
              <!-- 分类3：等级（下拉单选） -->
              <div v-else-if="item.nameEn === 'level'">
                <el-select v-model="openColList[idx]['value']" @change="handleSearch" clearable>
                  <el-option
                    v-for="item in clientLevelList"
                    :key="item.val"
                    :label="item.val"
                    :value="item.key"
                  />
                </el-select>
              </div>
              <!-- 分类4：创建时间、更新时间、首次会话时间、最后一次会话时间、首次电话联系时间、最后一次电话联系时间（时间选择）  -->
              <div v-else-if="item.styleType === 'datatimepicker'">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  class="crm-date-picker"
                  v-model="value1Date[idx]"
                  type="date"
                  placeholder="起始日期"
                ></el-date-picker>
                <el-time-picker
                  value-format="HH:mm:ss"
                  class="crm-time-picker"
                  v-model="value1Time[idx]"
                  :picker-options="{
                        selectableRange: '00:00:00 - 23:59:00'
                      }"
                  placeholder="时间"
                ></el-time-picker>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  class="crm-date-picker"
                  v-model="value2Date[idx]"
                  type="date"
                  placeholder="结束日期"
                ></el-date-picker>
                <el-time-picker
                  value-format="HH:mm:ss"
                  class="crm-time-picker"
                  v-model="value2Time[idx]"
                  @change="handleTimePickerChange(idx)"
                  :picker-options="{
                        selectableRange: '00:00:00 - 23:59:00'
                      }"
                  placeholder="时间"
                ></el-time-picker>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-checkbox-group>
      </el-scrollbar>
    </div>
    <div class="content-container">
      <div class="crm-title">
        <el-button
          v-if="$authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#connPlan_save')"
          type="primary"
          size="small"
          @click="handleCreatPlan"
          style="float:left;margin-right:10px;display:none;"
        >创建联系计划</el-button>
        <el-button
          v-if="$authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#deleteBatch')"
          size="small"
          @click="handleDel"
          class="crm-del-btn"
        >删除</el-button>
        <el-button
          v-if="$authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#import')"
          type="primary"
          size="small"
          @click="handleImport"
        >导入客户</el-button>
        <ExportExcelComponent
          :list="tableList"
          :headerList="openColList"
          :title="'导出客户'"
          :conditionsList="conditionsList"
        />
      </div>
      <!-- 表格组件： -->
      <el-scrollbar style="height: calc(100% - 44px)">
      <el-table
        ref="clientTable"
        v-loading="Loading"
        :data="tableList"
        style="width: 100%"
        :cell-style="cellStyleFunc"
        :header-cell-style="rowClass"
        @selection-change="changeFun"
        @row-dblclick="rowDblclick"
      >
        <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column
          prop="nameCn"
          label="姓名"
          width="120"
          align="center"
          fixed="left"
          show-overflow-tooltip
        />
        <el-table-column prop="phone" label="手机" width="120" align="center" fixed="left" />
        <el-table-column prop="email" label="邮箱" align="center" width="160" />
        <el-table-column prop="addr" label="地址" align="center" show-overflow-tooltip />
        <el-table-column
          prop="labelRespList"
          label="标签"
          align="center"
          width="125"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>
              <el-tag
                class="mg_r_5 crm-tag"
                effect="dark"
                v-for="item in scope.row.labelRespList"
                :key="item.id"
                :style="{'background':item.color}"
              >{{ item.name }}</el-tag>
              <el-popover placement="top-start" width="300" trigger="hover">
                <div class="tips-content">
                  <el-tag
                    class="mg_r_5 mg_b_5 crm-tag"
                    effect="dark"
                    v-for="item in scope.row.label"
                    :key="item.id"
                    :style="{'background':item.color}"
                  >{{ item.name }}</el-tag>
                </div>
                <el-tag
                  v-show="scope.row.showExtraLabel"
                  slot="reference"
                  effect="dark"
                  class="crm-extra-tag"
                >...</el-tag>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="property" label="属性" width="80" align="center" />
        <el-table-column prop="createDate" label="创建时间" align="center" width="160" />
        <el-table-column prop="modifyDate" label="更新时间" align="center" width="160" />
      </el-table>
      <!-- 分页数据 -->
      <el-row style="float:right;margin-right: 10px">
        <el-pagination
          class="pageStyle"
          background
          layout="total, prev, pager, next, jumper"
          :page-size.sync="listQuery.size"
          :current-page.sync="listQuery.current"
          :total="total"
          @current-change="handlePagination"
        ></el-pagination>
      </el-row>
      </el-scrollbar>
    </div>
    <ImportDialog v-if="importDialogVisible" @closeImportDialog="closeImportDialog" />
    <PlanDialog v-if="PlanDialogVisible" @closePlanDialog="closePlanDialog" />
    <ClientInfoDialog
      v-if="clientInfoDialog"
      :curRowId="curRowId"
      :customizeList="customizeList"
      @closeClientInfoDialog="closeClientInfoDialog"
      :editAuth="editAuth"
    />
  </div>
</template>
<script>
import ImportDialog from './components/ImportDialog'
import PlanDialog from './components/PlanDialog'
import ClientInfoDialog from './components/ClientInfoDialog'
import ExportExcelComponent from '@/components/ExportExcel'
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import { Message } from 'element-ui'
import authUtis from '@/utils/authUtis'

import {
  getClientInfo,
  getOpenCols,
  deleteCustomer,
  getCustomerField
} from '@/api/crm/clientInfo'
import { getAllLabelList } from '@/api/crm/widgets'

export default {
  components: {
    ImportDialog,
    ClientInfoDialog,
    ExportExcelComponent,
    PlanDialog,
    Breadcrumb
  },
  data() {
    return {
      msg: '客户管理',
      activeName: [],
      checkList: [],
      openColList: [],
      customizeList: [],
      Loading: false,
      total: 10,
      listQuery: {
        current: 1,
        size: 10
      },
      tableList: [],
      totalTableList: [],
      importDialogVisible: false,
      PlanDialogVisible: false,
      clientInfoDialog: false,
      curRowId: '',
      value1Date: [],
      value1Time: [],
      value2Date: [],
      value2Time: [],
      multipID: [],
      levelList: [{ path: '/client_mgr', title: '客户管理' }],
      clientLevelList: [
        { val: 'VIP', key: 1 },
        { val: '普通', key: 0 }
      ],
      conditionLevelList: [
        { name: '等于', key: 'EQ' },
        { name: '包含', key: 'LIKE' },
        { name: '为空', key: 'IS_NULL' },
        { name: '不为空', key: 'IS_NOT_NULL' }
      ],
      labelList: [],
      conditionsList: [],
      mould: 3001,
      editAuth: false
    }
  },
  created() {
    this.getColList()
    this.getList()
    this.getLabelList()
    this.getTotalTableList()
    this.getEditAuth()
  },
  methods: {
    getEditAuth() {
      this.editAuth = authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#edit')
    },
    rowClass() {
      return 'background:#F5F5F5;border-right: 1px solid #fff;text-align:center;'
    },
    getTotalTableList() {
      this.totalTableList = this.tableList
    },
    getLabelList() {
      // 获取所有的标签
      getAllLabelList().then(res => {
        this.labelList = res.data
      })
    },
    getColList() {
      // 获取自定义列固定参数source:AICC_CRM
      getOpenCols('AICC_CRM').then(res => {
        if (res.code === '2000') {
          const openColList = []
          const customizeList = []
          // 客户筛选条件样式分类（搜索，下拉单选，下拉多选，日期选择）
          res.data.forEach((item, idx) => {
            // 单行文本搜索
            if (
              item.nameEn === 'nameCn' ||
              item.nameEn === 'phone' ||
              item.nameEn === 'email' ||
              item.nameEn === 'addr' ||
              item.nameEn === 'remarks' ||
              item.nameEn === 'source' ||
              item.nameEn === 'property' ||
              item.nameEn === 'principalName'
            ) {
              item.styleType = 'textfield'
            }
            // 日期选择
            if (
              item.nameEn === 'createDate' ||
              item.nameEn === 'telConnFirst' ||
              item.nameEn === 'conversationFirst' ||
              item.nameEn === 'modifyDate' ||
              item.nameEn === 'telConnLast' ||
              item.nameEn === 'conversationLast'
            ) {
              item.styleType = 'datatimepicker'
            }
            // 去除visitId
            if (item.nameEn !== 'visitId') {
              openColList.push(item)
            }
            this.openColList = openColList
            this.customizeList = customizeList
            // 下拉单选
            if (item.nameEn && item.nameEn.indexOf('col') > -1) {
              item.styleType = item.type
              if (item.type === 'radio') {
                this.getColField({ tag: item.tag }).then(res => {
                  const colIndex = this.customizeList.findIndex(
                    col => col.nameEn === item.nameEn
                  )
                  this.$set(
                    this.customizeList[colIndex],
                    item.nameEn + 'list',
                    res.data[0].fieldValues
                  )
                  this.$set(
                    this.openColList[idx],
                    item.nameEn + 'list',
                    res.data[0].fieldValues
                  )
                })
              }
              customizeList.push(item)
            }
          })
        }
      })
    },
    getColField(option) {
      return new Promise((resolve, reject) => {
        getCustomerField(option)
          .then(res => {
            if (res.code === 2000) {
              resolve(res)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getList(conditionsList) {
      const option = {
        current: this.listQuery.current,
        size: this.listQuery.size,
        orders: null,
        search: { source: 'AICC_CRM' }
      }
      if (conditionsList) {
        option.search.conditions = conditionsList
      }
      getClientInfo(option).then(res => {
        if (res.code === '2000') {
          const data = res.data
          data.records.map(item => {
            if (item.labelRespList) {
              const labelList = JSON.parse(JSON.stringify(item.labelRespList))
              const length = labelList.length
              if (length > 1) {
                item.showExtraLabel = true
                // 第二个及以后的标签展示label
                item.label = labelList.slice(1, length + 1)
              } else {
                item.showExtraLabel = false
              }
              // 第一个标签展示用labelRespList
              item.labelRespList = labelList.splice(0, 1)
              return item
            }
          })
          this.tableList = data.records
          this.total = data.total
        } else {
          Message.error('查询失败!')
        }
      })
    },
    cellStyleFunc({ row, column }) {
      if (column.property === 'labelRespList') {
        return { cursor: 'pointer', 'text-align': 'left' }
      }
    },
    rowDblclick(row, column, event) {
      // console.log('row', row)
      this.curRowId = row.id
      this.clientInfoDialog = true
    },
    closeClientInfoDialog() {
      this.clientInfoDialog = false
      this.getList(this.conditionsList)
    },
    handleCheckChange(e) {
      setTimeout(() => {
        this.activeName = this.checkList
        this.openColList.forEach((item, idx) => {
          const checked = this.checkList.includes(item.name)
          if (!checked) {
            this.$set(this.openColList[idx], 'value', null)
            this.$set(this.openColList[idx], 'condition', null)
          }
        })
        this.handleSearch()
      }, 0.2 * 1000)
    },
    handlePagination() {
      // 分页查询的接口
      this.getList(this.conditionsList)
    },
    handleCreatPlan() {
      this.PlanDialogVisible = true
    },
    handleEdit() {
      // console.log('创建联系计划')
    },
    changeFun(row) {
      const _this = this
      _this.multipID = [] // 每次改动重置ID
      row.forEach(item => {
        _this.multipID.push(item.id)
      })
    },
    handleDel() {
      if (this.multipID.length > 0) {
        this.$confirm(
          '是否删除您所选中的客户，删除的客户信息将无法恢复',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            const data = { ids: this.multipID.join(','), mould: this.mould }
            deleteCustomer(data).then(res => {
              if (res.code === '2000') {
                Message.success('删除成功')
                this.getList(this.conditionsList)
              } else {
                Message.error('删除失败')
              }
            })
            this.$refs.clientTable.clearSelection()
          })
          .catch(() => {})
      } else {
        Message.warning('请选择要删除的客户')
      }
    },
    handleImport() {
      this.importDialogVisible = true
    },
    handleExport() {
      // console.log('导出')
    },
    closeImportDialog() {
      this.importDialogVisible = false
      this.getList(this.conditionsList)
    },
    closePlanDialog() {
      this.PlanDialogVisible = false
    },
    handleTimePickerChange(idx) {
      const dateTime =
        this.value1Date[idx] +
        ' ' +
        this.value1Time[idx] +
        ',' +
        this.value2Date[idx] +
        ' ' +
        this.value2Time[idx]
      this.$set(this.openColList[idx], 'value', dateTime)
      if (dateTime.indexOf('null') > -1) {
        this.value1Date[idx] = ''
        this.value1Time[idx] = ''
        this.value2Date[idx] = ''
        this.$set(this.openColList[idx], 'value', '')
      }
      this.handleSearch()
    },
    handleSearch() {
      let conditionsList = []
      this.openColList.forEach((item, idx) => {
        if (item.nameEn === 'label') {
          if (item.value && item.value.length > 0) {
            conditionsList.push(item)
          }
        } else if (item.styleType === 'textfield') {
          if (item.condition) {
            conditionsList.push(item)
          }
        } else if (item.value || item.value === 0) {
          conditionsList.push(item)
        }
      })
      conditionsList = JSON.parse(JSON.stringify(conditionsList))
      conditionsList = conditionsList.map(item => {
        item.name = item.nameEn
        // 标签多选查询
        if (item.name === 'label') {
          item.condition = 'IN'
          if (item.value.length === 1) {
            item.value = item.value[0]
          } else {
            item.value = item.value.join(',')
          }
          // 日期查询
        } else if (item.styleType === 'datatimepicker') {
          item.condition = 'BETWEEN'
        } else if (item.styleType === 'radio' || item.styleType === 'number') {
          item.condition = 'EQ'
        } else if (item.styleType === 'textfield') {
          if (item.value) {
            item.value = item.value.trim()
          }
        } else if (item.name === 'level') {
          item.condition = 'EQ'
        }
        return {
          name: item.name,
          value: item.value,
          condition: item.condition
        }
      })
      this.conditionsList = conditionsList
      this.getList(conditionsList)
    }
  }
}
</script>
<style scoped lang="scss">
.crm-client-aside {
  width: 200px;
  height: calc(100% - 50px);
  margin-top: 20px;
  padding-right: 10px;
  float: left;
  box-sizing: border-box;
  border-right: 1px solid #ebebeb;
  .crm-select-con {
    font-size: 14px;
    font-weight: 700;
    color: #666;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background-color: #f5f5f5;
  }
}
.el-checkbox {
  width: 100%;
  margin-right: 0px;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-collapse {
  border: none;
}
.crm-tag {
  border: none;
  height: 25px;
  line-height: 25px;
}
.crm-extra-tag {
  border: none;
  padding: 0 18px;
  background-color: #409eff;
  color: #fff;
  height: 25px;
  line-height: 25px;
}
.crm-client-info-dialog .el-row {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: 20px;
}
.mg_bt_10 {
  margin-bottom: 10px !important;
}
.mg_r_5 {
  margin-right: 5px;
}
.mg_b_5 {
  margin-bottom: 5px !important;
}
.content-container {
  width: calc(100% - 200px);
  height: calc(100% - 50px);
  padding: 20px 0 0 20px;
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  .crm-title {
    height: 30px;
    padding-bottom: 20px;
    text-align: right;
    margin-bottom: 10px;
    .crm-del-btn {
      float: left;
      margin-left: 0;
    }
  }
}
.subNav_Title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
}
.system-icon-sub-shrink {
  position: absolute;
  left: 180px;
  top: 50%;
  z-index: 3;
  width: 20px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background-color: #fff;
  color: #8796a6;
  border-radius: 4px 0 4px 0;
  box-shadow: 0 0 10px #eaebee;
  transition: left 0.1s;
}
.el-table {
  .cell {
    ::v-deep &.el-tooltip {
      >div {
        display: flex;
        .crm-tag {
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .el-popover__reference {
          padding: 0 6px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.crm-client-aside {
  .el-collapse-item__header {
    border-bottom: none;
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
  }
  .el-collapse-item__arrow {
    display: none;
  }
  .el-input__inner {
    height: 35px;
    font-size: 12px;
    color: #666;
  }
  .el-select .el-input .el-select__caret {
    line-height: 35px !important;
  }
  .crm-date-picker {
    width: 51% !important;
    font-size: 12px;
    margin-top: 5px;
    .el-input__inner {
      padding-left: 5px !important;
      padding-right: 10px !important;
    }
    .el-input__prefix {
      display: none;
    }
    .el-input__suffix {
      right: -5px;
    }
  }
  .crm-time-picker {
    width: 45% !important;
    margin-left: 5px;
    margin-top: 5px;
    font-size: 12px;
    .el-input__inner {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
    .el-input__prefix {
      display: none;
    }
    .el-input__suffix {
      right: -5px;
    }
  }
  .el-collapse-item__header.is-active {
    background-color: #f7f8fa;
  }
  .el-collapse-item__content {
    padding: 10px !important;
    border: 1px solid #e1e3e6;
    margin-top: 3px;
    background-color: #f7f8fa;
    .el-date-editor {
      width: 165px;
    }
  }
  .crm-search .crm-input {
    margin-top: 10px;
    .el-input__suffix {
      line-height: 40px;
      padding-right: 5px;
      cursor: pointer;
    }
  }
  .crm-group {
    position: relative;
    height: calc(100% - 40px - 20px);
    .el-scrollbar__wrap {
      margin-right: 0 !important;
    }
  }
  .el-checkbox-group {
    /*height: 100%;*/
    .el-checkbox__label {
      font-size: 12px;
      color: #666;
    }
  }
  .el-checkbox-group::after {
    content: '';
    position: absolute;
    display: block;
    width: 200px;
    height: 1px;
    right: 1px;
    bottom: 5px;
    background-color: transparent;
  }
}
.crm-client-container .content-container {
  .el-table td {
    cursor: pointer;
  }
  .el-table__fixed:before{
    background-color: transparent;
  }
}
</style>
